import {memo, useMemo} from 'react';
import {getPaginationInfo} from '../../../common/getPaginationInfo';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {PaginationProps} from './PaginationProps.interface';

const Pagination = memo(
  ({
    currentPage,
    totalCount,
    contentsPerPage,
    pagingSize,
    onChangePage,
  }: PaginationProps) => {
    const {prevPage, nextPage, pages} = useMemo(
      () =>
        getPaginationInfo({
          totalCount,
          currentPage,
          contentsPerPage,
          pagingSize,
        }),
      [totalCount, currentPage, contentsPerPage, pagingSize]
    );

    return (
      <div className="flex items-center justify-center p-20pxr">
        <div className="mr-8pxr h-12pxr w-12pxr">
          {prevPage !== undefined && (
            <Icon
              type={IconType.ButtonArrowLeft}
              data-page={prevPage}
              onClick={onChangePage}
              className="w-full"
            />
          )}
        </div>
        {pages.map(pageNum => {
          return (
            <Text
              className={twMerge(
                'font-small2 m-10pxr cursor-pointer text-theme-solid-40 no-underline',
                pageNum === currentPage &&
                  'font-small2-bold text-theme-solid-100'
              )}
              key={pageNum}
              data-page={pageNum}
              onClick={onChangePage}
            >
              {pageNum}
            </Text>
          );
        })}
        <div className="ml-8pxr h-12pxr w-12pxr">
          {nextPage !== undefined && (
            <Icon
              type={IconType.ButtonArrowRight}
              data-page={nextPage}
              onClick={onChangePage}
              className="w-full"
            />
          )}
        </div>
      </div>
    );
  }
);

export {Pagination};
